const Strings = {
  AVAILABLE: {
    SE: 'Ledig',
    EN: 'Available '
  },
  BOOKED_BY_ME: {
    SE: 'Bokad av mig',
    EN: 'Booked by me'
  },
  OCCUPIED: {
    SE: 'Upptagen',
    EN: 'Occupied'
  },
  OCCUPIED_ALERT_HEADER: {
    SE: 'Tiden är upptagen',
    EN: 'Time is occupied'
  },
  OCCUPIED_ALERT: {
    SE: 'Tiden är redan bokad, var god välj ett annat pass.',
    EN: 'The time is already booked, please choose another one.'
  },
  OCCUPIED_BY_ALERT: {
    SE: 'Tiden är redan bokad av lägenhet {apartmentNumber} {apartmentAddress},\nvar god välj ett annat pass.',
    EN: 'The time is already booked by apartment {apartmentNumber} {apartmentAddress},\nplease choose another one.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  REQUEST_BOOK_TIME: {
    SE: 'Boka tid',
    EN: 'Book time'
  },
  REQUEST_BOOK_TIME_INFO: {
    SE: 'Är du säker på att du vill boka tiden?',
    EN: 'Are you sure you wish to book the time?'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  },
  REQUEST_UNBOOK_TIME: {
    SE: 'Avboka tid',
    EN: 'Unbook time'
  },
  REQUEST_UNBOOK_TIME_INFO: {
    SE: 'Är du säker på att du vill avboka tiden?',
    EN: 'Are you sure your wish to unbook the time?'
  },
  NO_TIMES_TODAY: {
    SE: 'Det finns inga tider att boka idag.',
    EN: 'There are no times to book today.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/BookingSystemItems/strings.js